import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { enUS, es } from 'date-fns/locale';
import { Groups } from '@mui/icons-material';
import NotificationRowContent from 'components/notifications/NotificationRowContent';
import { dateFormat } from 'common/constants/date';
import { convertUtcToLocalTime } from 'common/utils/date';

function GroupSessionCreatedNotification({ notification }) {
  const { t, i18n } = useTranslation(['notifications']);
  const dateLocale = i18n.language === 'es' ? es : enUS;

  const {
    data: { trainer_name: trainerName, start_date: startDate, weeks }
  } = notification;

  const formattedDate = convertUtcToLocalTime(startDate, dateFormat, dateLocale);

  return (
    <NotificationRowContent
      notification={notification}
      icon={Groups}
      title={t('groupSession.created.title', { ns: 'notifications' })}
      body={t('groupSession.created.body', {
        trainer: trainerName,
        weeks,
        date: formattedDate,
        ns: 'notifications'
      })}
    />
  );
}

GroupSessionCreatedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      start_date: PropTypes.string.isRequired,
      trainer_name: PropTypes.string.isRequired,
      weeks: PropTypes.number.isRequired
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default GroupSessionCreatedNotification;
